import { render, staticRenderFns } from "./UAMProfile.vue?vue&type=template&id=17d90d2a"
import script from "./UAMProfile.vue?vue&type=script&lang=js"
export * from "./UAMProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports